module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Spacing_After"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "BigNoodleTitling",
      "font-size": "3.33em"
    }
  }, [_vm._v("PART TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body__And__Centre_Alignment__And__Left_Indent"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "BigNoodleTitling",
      "font-size": "1.67em"
    }
  }, [_vm._v("PROBLEM WITH AUTHORITY")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_vm._v("“The mark of truth is that it’s so obscenely complex when you get up close with it that it would drive you mad to stare at it for longer than ten seconds. Occam’s razor isn’t for understanding the world; it’s for slitting your wrists and gouging out your eyes before such understanding turns you into a raving lunatic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_First_Paragraph__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('i', [_vm._v("- Jadim Cartarssi, Amateur Philosopher and Part-time Raving Lunatic")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Print_Body"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3655c003","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0011.vue
// module id = 93
// module chunks = 0